import { render } from "./ClientsMenu.vue?vue&type=template&id=62c9eeb6&scoped=true"
import script from "./ClientsMenu.vue?vue&type=script&lang=js"
export * from "./ClientsMenu.vue?vue&type=script&lang=js"

import "./ClientsMenu.vue?vue&type=style&index=0&id=62c9eeb6&scoped=true&lang=css"

import exportComponent from "C:\\ClusterTrade\\NXM_CLUSTERTRADE\\nxm_clustertrade_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62c9eeb6"]])

export default __exports__